import { isDeliveryPlanLocked } from '../../../sales-order-status/is-delivery-plan-locked.js';
import { SHIP_DATE_CLEARED_MESSAGE } from './ship-date-cleared-message.js';
/** The message when an edit clears the ship date (`null`) while the delivery plan is locked, else null. */
export function shipDateClearedError({ statusId, shipDate, deliveryScheduled, }) {
    if (shipDate !== null)
        return null;
    return isDeliveryPlanLocked({ statusId, deliveryScheduled }) ? SHIP_DATE_CLEARED_MESSAGE : null;
}
//# sourceMappingURL=ship-date-cleared-error.js.map